// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceStatusType } from './IInvoiceStatusType';
import {
    IInvoiceStatusTypeFromJSON,
    IInvoiceStatusTypeFromJSONTyped,
    IInvoiceStatusTypeToJSON,
    IInvoiceStatusTypeToJSONTyped,
} from './IInvoiceStatusType';

/**
 * 
 * @export
 * @interface IInvoiceReplenishmentMetricsItemDto
 */
export interface IInvoiceReplenishmentMetricsItemDto {
    /**
     * 
     * @type {number}
     * @memberof IInvoiceReplenishmentMetricsItemDto
     */
    invoice_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceReplenishmentMetricsItemDto
     */
    invoice_date?: Date;
    /**
     * 
     * @type {IInvoiceStatusType}
     * @memberof IInvoiceReplenishmentMetricsItemDto
     */
    invoice_status?: IInvoiceStatusType;
}



/**
 * Check if a given object implements the IInvoiceReplenishmentMetricsItemDto interface.
 */
export function instanceOfIInvoiceReplenishmentMetricsItemDto(value: object): value is IInvoiceReplenishmentMetricsItemDto {
    return true;
}

export function IInvoiceReplenishmentMetricsItemDtoFromJSON(json: any): IInvoiceReplenishmentMetricsItemDto {
    return IInvoiceReplenishmentMetricsItemDtoFromJSONTyped(json, false);
}

export function IInvoiceReplenishmentMetricsItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceReplenishmentMetricsItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'invoice_id': json['invoice_id'] == null ? undefined : json['invoice_id'],
        'invoice_date': json['invoice_date'] == null ? undefined : (new Date(json['invoice_date'])),
        'invoice_status': json['invoice_status'] == null ? undefined : IInvoiceStatusTypeFromJSON(json['invoice_status']),
    };
}

export function IInvoiceReplenishmentMetricsItemDtoToJSON(json: any): IInvoiceReplenishmentMetricsItemDto {
    return IInvoiceReplenishmentMetricsItemDtoToJSONTyped(json, false);
}

export function IInvoiceReplenishmentMetricsItemDtoToJSONTyped(value?: IInvoiceReplenishmentMetricsItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoice_id': value['invoice_id'],
        'invoice_date': value['invoice_date'] == null ? undefined : ((value['invoice_date']).toISOString()),
        'invoice_status': IInvoiceStatusTypeToJSON(value['invoice_status']),
    };
}

